import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';

import commonStyles from '../styles';

const styles = (theme) => {
  const common = {
    ...commonStyles(theme),
  };

  return {
    label: common.label,
    percentage: {
      fontSize: 18,
      lineHeight: '36px',
      verticalAlign: 'top',
    },
    root: {
      textAlign: 'center',
    },
    value: common.value,
  };
};

const DisplayRateAmount = ({ className, classes, isPercentage, label, value }) => {
  const hasValue = value !== undefined && value !== null;
  return (
    <div className={classnames(classes.root, className)}>
      <RawHtml type="span" className={classes.label}>
        {label}
      </RawHtml>{' '}
      <span className={classnames('val', classes.value)}>
        {hasValue ? value : 'N/A'}
        {isPercentage && hasValue && <span className={classes.percentage}>%</span>}
      </span>
    </div>
  );
};

DisplayRateAmount.propTypes = {
  className: PropTypes.string,
  isPercentage: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

DisplayRateAmount.defaultProps = {
  className: 'apr',
  isPercentage: false,
  value: undefined,
};

export default withStyles(styles)(DisplayRateAmount);
